module.exports = __webpack_public_path__ + "static/img/header.2889f6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.jpg
// module id = Y5I1
// module chunks = 0